import { Button } from '@mui/material';

interface AdministrationButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export function StyledButton({ label, onClick, disabled }: AdministrationButtonProps) {
  return (
    <Button disabled={disabled} onClick={onClick} size="large" variant="contained">
      {label}
    </Button>
  );
}
